/**
 * Highchart Style definitions. This will be merged with chart data
 * and set on the highchart component.
 * For available attributes for highcharts please refer https://api.highcharts.com/highcharts/
 */
export const highchartsStyle = {
  plotOptions: {
    line: {
      dataLabels: {
        enabled: false,
      },
      enableMouseTracking: true,
    },
  },
  xAxis: {
    title: {
      text: '',
    },
    crosshair: {
      enabled: true,
      color: '#E66400',
      dashStyle: 'longdash',
    },
    showFirstLabel: false,
    showLastLabel: false,
    visible: true,
    lineWidth: 1,
    labels: {
      enabled: false,
    },
    tickLength: 0,
  },
  yAxis: [{
    title: {
      text: '',
    },
    tickPixelInterval: 30,
    gridLineDashStyle: 'dash',
    visible: true,
    showFirstLabel: false,
    showLastLabel: false,
  }, {
    title: {
      text: '',
    },
    tickPixelInterval: 30,
    gridLineDashStyle: 'dash',
    visible: true,
    showFirstLabel: false,
    showLastLabel: false,
    opposite: true,
  }],
  tooltip: {
    backgroundColor: '#ffffff',
    borderRadius: 0,
    borderColor: '#AAAAAA',
    borderWidth: 2,
    useHTML: true,
    shared: true,
    shadow: false,
    valueDecimals: 2,
  },
  chart: {
    spacingTop: 0,
    spacingLeft: 0,
    spacingRight: 0,
    spacingBottom: 20,
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
};

export const highchartsStyleVNextOverride = {
  chart: {
    height: 123,
  },
  xAxis: {
    crosshair: {
      color: 'rgba(0,0,0,0.1)',
    },
  },
};
